export default "__VITE_ASSET__3yEalGlz__"